import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Logo } from "../../components/Logo";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Lock, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../../context/AuthContext";

function formatError(detail) {
  if (!detail) return "Login failed. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e.msg || "").join(" ");
  return String(detail);
}

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      navigate("/admin");
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="navy-grid-bg flex min-h-screen items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="mb-6 flex justify-center"><Logo dark /></div>
        <form onSubmit={submit} data-testid="admin-login-form"
          className="rounded-3xl border border-slate-200 bg-white p-8 shadow-2xl">
          <div className="mb-6 flex items-center gap-3">
            <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#ECFDF5] text-[#059669]"><Lock className="h-5 w-5" /></span>
            <div>
              <h1 className="font-display text-xl font-bold text-[#0B1B3D]">Admin Panel</h1>
              <p className="text-sm text-slate-500">Sign in to manage the catalogue</p>
            </div>
          </div>
          <div className="space-y-4">
            <div><Label>Email</Label><Input data-testid="admin-login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@tfm.com" /></div>
            <div><Label>Password</Label><Input data-testid="admin-passcode-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" /></div>
          </div>
          <Button type="submit" disabled={loading} data-testid="admin-login-submit-btn"
            className="mt-6 w-full bg-[#0B1B3D] font-bold hover:bg-[#1E293B]">
            {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Sign In
          </Button>
        </form>
      </div>
    </div>
  );
}
